import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { DownloadableCouponRow } from '@models/coupon';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import DownloadIcon from './DownloadIcon';
import useDownloadCoupon from './hooks/useDownloadCoupon';

interface Props {
    coupon:DownloadableCouponRow;
}

function DownloadAbleCoupon({ coupon }:Props) {
    const {
        couponImage, couponTitle, eventEndAt, availableShops,
    } = coupon;
    const { t } = useTranslation('coupon');
    const downloadCoupon = useDownloadCoupon(coupon);
    return (
        <Container fullWidth spacing={4} align='center'>
            <ImageWrapper>
                <Thumbnail src={couponImage} alt={couponTitle} width={80} height={80} />
            </ImageWrapper>
            <TextContainer spacing={1}>
                {availableShops !== '전체매장' && (
                    <Text size='body-long' ellipsis>{availableShops}</Text>
                )}
                <Text size='title' fontWeight='medium' ellipsis>{couponTitle}</Text>
                <Text color='var(--color-text-secondary)' size='body-long'>
                    {t('validity', {
                        date: dayjs(eventEndAt)
                            .subtract(1, 'second')
                            .format('YYYY.MM.DD'),
                    })}
                </Text>
            </TextContainer>
            <DownloadButton type='button' onClick={downloadCoupon} >
                <DownloadIcon/>
            </DownloadButton>
        </Container>
    );
}

const Container = styled(Row)`
    position: relative;
`;

const ImageWrapper = styled.div`
    border-radius: var(--radius-xs);
    flex-shrink: 0;
    height: 80px;
    overflow: hidden;
    width: 80px;
`;

const Thumbnail = styled(Image)`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

const TextContainer = styled(Column)`
    flex: 1;
    min-width: 0;
`;

const DownloadButton = styled.button`
    align-items: center;
    background-color: var(--color-gray1);
    border-radius: var(--radius-sm);
    display: flex;
    flex-shrink: 0;
    height: 32px;
    justify-content: center;
    padding: var(--spacing-1);
    width: 32px;
    ${pressActionEffect}
`;

export default DownloadAbleCoupon;
